import { API } from 'aws-amplify';
import { SSA_PREFERENCES_COURSE_CHECKS_URL_APPEND } from 'constants';

export const getCourseChecks = async (studentId, week, semester) => {
  const response = await API.get(
    'delta-api',
    `${SSA_PREFERENCES_COURSE_CHECKS_URL_APPEND}${studentId}`,
    {
      headers: {},
      queryStringParameters: {
        week: week,
        semester: semester,
      },
    }
  );

  return response;
};

export const postCourseChecks = async (studentId, payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post(
    'delta-api',
    `${SSA_PREFERENCES_COURSE_CHECKS_URL_APPEND}${studentId}`,
    myPayload
  );
};

export const deleteCourseCheck = async (studentId, courseName, week, semester) => {
  await API.del(
    'delta-api',
    `${SSA_PREFERENCES_COURSE_CHECKS_URL_APPEND}${studentId}/${encodeURIComponent(
      courseName
    )}`,
    {
      queryStringParameters: {
        week: week,
        semester: semester,
      },
    }
  );
};
